import React, { lazy, Suspense, useEffect } from "react"
import { Routes, BrowserRouter, Route } from "react-router-dom"
import { ErrorBoundary } from "@sentry/react"
// Component

import Loader from "helper/component/loader"
import NotFound from "helper/component/404"
import LoadingScreen from "helper/component/loadingscreen"
import Fallback from "helper/component/fallback"
import { componentLoader } from "helper"
import Navigation from "component/Navigation"
import { useCSSVariable } from "helper/hooks/useCSSVariable"
import ModalCont from 'component/Modal';
import ToastNotification from "component/ToastNotification"
import { lang_json, loader } from "signals/base"
import { set_token } from "services/auth"
import { useSignalEffect } from "@preact/signals-react"
import { name, openToast } from "signals/modal"
import RegistrationForm from "pages/RegistrationForm"

//Layout
const BasePage = lazy(() => componentLoader(() => import("layouts/BasePage")))

// Pages
const Home = lazy(() => componentLoader(() => import("pages/Home")))
// const RegistrationForm = lazy(() => componentLoader(() => import("pages/RegistrationForm")))

const ViewportRestrict = React.lazy(() => import("Remote/ViewportRestrict"));

export const Main = () => {
	useCSSVariable({ list: lang_json.value });

	useEffect(() => {
		set_token();
	}, []);

	useSignalEffect(() => {
		let el = document.documentElement;
		if (name.value?.terms) {
			el.style.position = 'fixed';
		}
		else {
			el.style.position = 'relative';
		}
	}, [])


	return (
		<BrowserRouter basename={process.env.REACT_APP_BASENAME}>
			<div id="Main" className="main-panel" >
				<ErrorBoundary fallback={Fallback}>
					<Suspense fallback={<LoadingScreen />}>
						<ViewportRestrict display={false} type="portrait" />
						<Loader loader={loader.value} />
						<div className="content-container">
							{openToast.value &&
								<div className="overlay" style={{ display: 'flex', zIndex: '1' }}></div>
							}
							<Navigation />
							<BasePage>
								<Routes>
									<Route path="/" element={<Home />} />
									<Route path="/form" element={<RegistrationForm />} />
									<Route path="/form/:form_id" element={<RegistrationForm />} />
									<Route path="*" element={<NotFound />} />
								</Routes>
							</BasePage>
						</div>
						<ToastNotification />
						<ModalCont />
					</Suspense>
				</ErrorBoundary>
			</div>
		</BrowserRouter>
	)
}

export default Main
